/* SRareTCG — theme.js
   No dependencies. Everything degrades to a working page without JS:
   the condition matrix is real <form> posts, nav is real links. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Mobile drawer -------------------------------------------------- */
  function initDrawer() {
    var drawer  = $('[data-drawer]');
    var overlay = $('[data-overlay]');
    if (!drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', drawer);
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Nested menu toggles inside the drawer */
    $$('[data-drawer-toggle]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.nextElementSibling;
        if (!sub) return;
        var open = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---- Facet drawer (collection, mobile) ------------------------------ */
  function initFacets() {
    var panel = $('[data-facets]');
    if (!panel) return;
    $$('[data-facets-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { panel.classList.toggle('is-open'); });
    });
    /* Auto-submit the facet form so filtering needs no Apply button */
    var form = $('[data-facet-form]');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }
  }

  /* ---- Accordions ------------------------------------------------------ */
  function initAccordion() {
    $$('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---- Quantity steppers ---------------------------------------------- */
  function initQty() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          var min  = parseInt(input.getAttribute('min'), 10) || 1;
          var max  = parseInt(input.getAttribute('max'), 10) || Infinity;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, Math.min(max, next));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Product gallery ------------------------------------------------- */
  function initGallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) { main.src = src; main.alt = alt; }
        $$('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Condition matrix add-to-cart ------------------------------------
     Each row is a real form POST to /cart/add. We intercept it to keep the
     buyer on the page — a singles buyer adds five or six rows in a row and
     a full page reload between each one is the whole reason singles carts
     get abandoned. If fetch fails we let the native form submit. */
  function initCondAdd() {
    $$('[data-cond-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* native submit */
        e.preventDefault();

        var btn = $('button[type="submit"]', form);
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (btn) { btn.textContent = 'Added ✓'; }
            setTimeout(function () {
              if (btn) { btn.textContent = original; btn.disabled = false; }
            }, 1400);
          })
          .catch(function () {
            form.removeEventListener('submit', arguments.callee);
            if (btn) { btn.disabled = false; btn.textContent = original; }
            form.submit();
          });
      });
    });
  }

  function updateCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---- Sort select ------------------------------------------------------ */
  function initSort() {
    var sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }


  /* ---- Variant picker -------------------------------------------------- */
  /* Without this the option <select>s change nothing: the price, the compare-at
     price, the stock badge and — the one that actually costs money — the hidden
     `id` the form posts to /cart/add all stay on whichever variant rendered. */
  function initVariants() {
    /* anchored on the class the form already carries: Liquid's form tag takes
       attributes, but hyphenated data-* keys are a fragile thing to depend on */
    var form = $('form.pdp__buy');
    if (!form) return;
    var tag = $('[data-variant-json]');
    if (!tag) return;

    var variants;
    try { variants = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var selects = $$('[data-variant-option]', form);
    if (!selects.length) return;

    var idInput = $('[data-variant-id]', form);
    var btn     = $('[data-add-btn]', form);
    var qty     = $('#qty', form);
    var priceRow = $('[data-price-row]');
    var nowEl   = priceRow && $('.price__now', priceRow);
    var wasEl   = priceRow && $('.price__was', priceRow);
    var fromEl  = priceRow && $('.price__from', priceRow);
    var stock   = $('[data-stock]');
    var mainImg = $('[data-gallery-main]');

    function chosen() {
      return selects
        .slice()
        .sort(function (a, b) {
          return (+a.getAttribute('data-variant-option')) - (+b.getAttribute('data-variant-option'));
        })
        .map(function (s) { return s.value; });
    }

    function match(want) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options || [];
        if (o.length !== want.length) continue;
        var same = true;
        for (var j = 0; j < want.length; j++) {
          if (String(o[j]) !== String(want[j])) { same = false; break; }
        }
        if (same) return variants[i];
      }
      return null;
    }

    function setPrice(v) {
      if (!nowEl) return;
      nowEl.textContent = v.price;
      /* "From" only belongs on a summary price, never on a chosen variant */
      if (fromEl) fromEl.hidden = true;

      if (v.compare) {
        if (wasEl) {
          wasEl.textContent = v.compare;
          wasEl.hidden = false;
        } else {
          wasEl = document.createElement('s');
          wasEl.className = 'price__was';
          wasEl.textContent = v.compare;
          nowEl.parentNode.appendChild(wasEl);
        }
      } else if (wasEl) {
        wasEl.hidden = true;
      }
    }

    function apply() {
      var v = match(chosen());

      if (!v) {
        /* a combination the shop does not stock */
        if (btn) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-label-unavailable') || 'Unavailable';
        }
        if (idInput) idInput.value = '';
        return;
      }

      if (idInput) idInput.value = v.id;

      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available
          ? (btn.getAttribute('data-label-available') || 'Add to cart')
          : (btn.getAttribute('data-label-soldout') || 'Sold out');
      }

      setPrice(v);

      if (stock) {
        stock.textContent = v.available ? 'In stock' : 'Sold out';
        stock.className = v.available ? 'badge badge--stock badge--dot' : 'badge badge--out';
      }

      if (qty) {
        if (v.tracked && v.policy === 'deny' && v.qty > 0) {
          qty.max = v.qty;
          if (+qty.value > v.qty) qty.value = v.qty;
        } else {
          qty.removeAttribute('max');
        }
      }

      if (mainImg && v.image) {
        mainImg.src = v.image;
        $$('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-src') === v.image);
        });
      }

      /* keep the URL shareable and the back button honest */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', apply); });
    apply();   /* also corrects a ?variant= deep link the markup rendered without */
  }

  function init() {
    initDrawer();
    initFacets();
    initAccordion();
    initQty();
    initGallery();
    initVariants();
    initCondAdd();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
